import React, { useState } from "react";
import { Row, Col, Modal, Form, Button } from "react-bootstrap";
import jsDig from "utils/jsDig";

export default function OrgPickerModal(props) {
  const [selfShow, setSelfShow] = useState(true);
  const changeOrg = () => {
    const selectedOrgId = $("#org-picker").val();
    $.ajax({
      type: "POST",
      url: "/datapulse/organization/select-organization/",
      data: {
        org_id: selectedOrgId,
      },
    });
  };

  return (
    <Modal
      className="change-orgs-modal"
      centered
      show={props.force_selection ? selfShow : props.show}
      onHide={props.force_selection ? () => {} : () => props.setShow(false)}>
      <Modal.Header closeButton={props.force_selection ? false : true}>
        <Modal.Title>
          <h4>Change Organization</h4>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="pb-3">
          <p className="f14 pb-3">Select organization to view:</p>
          <div className="select-wrapper">
            <select
              className="lite-select"
              name="organizataion"
              id="org-picker"
              defaultValue={jsDig(["selectedOrg", "id"], props) ? jsDig(["selectedOrg", "id"], props) : "0"}>
              <option value="0" disabled hidden>
                Choose One
              </option>
              {props.organizations.map((org) => {
                return (
                  <React.Fragment key={org.id}>
                    <option value={org.id}>{org.name}</option>
                  </React.Fragment>
                );
              })}
            </select>
          </div>
        </div>
        <div className="mt-3 action-buttons d-flex gap-12">
          {props.force_selection != true && (
            <button type="button" className="button b-type-primary b-size-normal" onClick={() => props.setShow(false)}>
              Cancel
            </button>
          )}
          <button
            type="button"
            className="button b-type-primary b-size-normal b-color-green"
            onClick={() => {
              if (props.force_selection) {
                setSelfShow(false);
              } else {
                props.setShow(false);
              }
              changeOrg();
            }}>
            Change Organization
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
}
